/**
 * Putt Performance Reducers
 */
import {
    PUTTPERFORMANCE_ACTION,
    ALL_PUTTPERFORMANCE,
    ADD_PUTTPERFORMANCE,
    FETCH_PUTTPERFORMANCE,
    EDIT_PUTTPERFORMANCE,
    DELETE_PUTTPERFORMANCE,
    FETCH_PUTTDISTANCE,
    FETCH_PUTTPERFORMANCECHART,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    puttperformancelist:[],
    particularputtperformance:[],
    puttperformancechart:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case PUTTPERFORMANCE_ACTION:
            return { ...state, loading: true };       

        case ALL_PUTTPERFORMANCE:
            return { ...state, loading: false, puttperformancelist: action.payload };     
            
        case ADD_PUTTPERFORMANCE:
            return { ...state, loading: false };     
         
        case FETCH_PUTTPERFORMANCE:
            return { ...state, loading: false, particularputtperformance: action.payload };  
            
        case EDIT_PUTTPERFORMANCE:
            return { ...state, loading: false }; 
            
        case DELETE_PUTTPERFORMANCE:
            return { ...state, loading: false };
            
        case FETCH_PUTTDISTANCE:
            return { ...state, loading: false };

        case FETCH_PUTTPERFORMANCECHART:
            return { ...state, loading: false, puttperformancechart: action.payload }; 

        default: return { ...state };

     }
 }